export const EngineSize = {
  None: 0,
  One: 6,
  Two: 7,
  Three: 8,
  Four: 1,
  Five: 9,
  Six: 2,
  Eight: 3,
  Ten: 4,
  Twelve: 5,
}

export const EngineSizes = {
  6: '1',
  7: '2',
  8: '3',
  1: '4',
  9: '5',
  2: '6',
  3: '8',
  4: '10',
  5: '12',
}

export const EngineSizeFilters = [
  { label: '4', value: EngineSize.Four },
  { label: '6', value: EngineSize.Six },
  { label: '8', value: EngineSize.Eight },
  {
    label: 'Other',
    value: [
      EngineSize.Ten,
      EngineSize.Twelve,
      EngineSize.One,
      EngineSize.Two,
      EngineSize.Three,
      EngineSize.Five,
    ],
  },
]

export const NormalizedEngineSizeFilters = Object.assign(
  {},
  ...EngineSizeFilters.map((x) => ({ [x.value]: x.label })),
)
